import React, { useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import FormularioContactanosDashboard from "../pages/Contactanos/FormularioContactanosDashboard";
import ListaContactanos from "../pages/Contactanos/ListaContactanos";
import ListaInfoContactanos from "../pages/Contactanos/ListaInfoContactanos";
import ContactPages from "../pages/Contactanos/ContactPages";

const DashboardContantanosWeb = () => {
    const [infoContactanosSeleccionado, setInfoContactanosSeleccionado] = useState(null);
    
    // Función para manejar la edición del infoContactanos
    const handleEditarInfoContactanos = (infocontactanos) => {
        setInfoContactanosSeleccionado(infocontactanos);
        console.log('Estoy en DashboardContantanos ' + infocontactanos);
    };

    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>

            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección de contactanos
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>
                {/*Formulario para agregar el contenido a la página web */}
                <FormularioContactanosDashboard infoContactanosSeleccionado={infoContactanosSeleccionado}/>

                <Typography 
                    variant='h5' 
                    sx={{ 
                        width: 'auto',
                        alignItems: 'center',
                        textAlign: 'center',
                        '@media (max-width: 600px)': {  // Ajustes para móviles
                            fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                            margin: '1% 5%',
                        },
                    }}
                >
                    Sección de los contactos que nos escribe
                </Typography>

                <Divider 
                    sx={{
                        backgroundColor: '#8E0505',
                        width: '100%', // El ancho se ajusta a todo el espacio disponible
                        height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                        margin: '1% 0%',
                        borderWidth: '0.1px',
                    }} 
                />
                
                {/*Lista de la informació que se muestra en la pagina de contactanos*/}
                <ListaInfoContactanos onEditar={handleEditarInfoContactanos} />

                {/*Lista de los nuevos contactos*/}
                <ListaContactanos />

            </Box>

            <ContactPages/>

        </Box>
    );
}

export default DashboardContantanosWeb;